import { apiClient } from '../../apiClient';

const extractData = (res) => res.data;

export const bookingService = {
  getAvailableSlots: (shopId, date, { barberId, serviceId, productId } = {}) => {
    const params = new URLSearchParams({ shopId, date });
    if (barberId) params.append('barberId', barberId);
    if (serviceId) params.append('serviceId', serviceId);
    if (productId) params.append('productId', productId);
    return apiClient.get(`/bookings/slots?${params}`).then(extractData);
  },
  createBooking: (data) => apiClient.post('/bookings', data).then(extractData),
  getMyBookings: (status) =>
    apiClient.get(status ? `/bookings/my?status=${status}` : '/bookings/my').then(extractData),
  cancelBooking: (bookingId) => apiClient.post(`/bookings/${bookingId}/cancel`).then(extractData),
  updateBookingStatus: (bookingId, status) =>
    apiClient.patch(`/bookings/${bookingId}/status`, { status }).then(extractData),
};
